import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { fetchOrganizationDetails } from '../../Store/IAM/iamSlice'
import remarkIcon from './Frame 433.png'
import searchIcon from './search.png'
import refreshIcon from './refresh.png'
import { useSelector } from 'react-redux'
import moment from 'moment'
import './iamSidebar.css'

const IamSidebar = () => {
  const dispatch = useDispatch()
  const [searchTerm, setSearchTerm] = useState('')
  const [auditData, setAuditData] = useState([])
  const [selectedDate, setSelectedDate] = useState(
    moment().format('YYYY-MM-DD')
  )
  const [isDataFetched, setIsDataFetched] = useState(false)
  const [agents, setAgents] = useState({})
  const [caseIds, setCaseIds] = useState([])
  const [usernames, setUsernames] = useState([])
  const user = localStorage.getItem('insuranceUser')
  const user_info = JSON.parse(user)
  const token = user_info?.token
  const org_id = user_info?.org_id
  const org_name = user_info?.org_name
  // console.log("932", org_id);
  const [orgName, setOrgName] = useState('')
  const [programs, setPrograms] = useState([]) 
  const userDataStore = useSelector(state => state.appStore?.user)
  console.log('52-data', userDataStore)
  const fetchOrgData = async orgID => {
    console.log('Fetching data for orgID:', orgID)

    try {
      const response = await axios.post(
        '/auth/OrgData',
        { orgID },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      console.log("res",response.data);
      
      // Fetch programs
      const programsResp = await axios.get('/auth/organisation_programs', {
        params: { org_id: orgID },
        headers: { Authorization: `Bearer ${token}` }
      })

      // Extract program names for dropdown
      const programNames =
        programsResp.data?.programs?.map(p => p.prog_name) || []
      setPrograms(programNames) // ✅ store in state
      const fetchedOrgData = response.data[0]?.orgData

      console.log('fetchedOrgData:', fetchedOrgData)
      setOrgName(response.data[0]?.orgName)
      if (!fetchedOrgData || !Array.isArray(fetchedOrgData)) {
        console.warn('Org data is null or not an array.')
        setAuditData([])
        setIsDataFetched(true)
        return
      }

      const formattedOrgData = fetchedOrgData.map(row => ({
        date: row?.date || null,
        caseId: row?.audit || '',
        status: row?.used || '',
        audit: row?.audit || '',
        agent: row?.agentName || 'test',
        userID: row?.userID || '',
        remark: row?.remark || '',
        program:row?.program
      }))

      console.log('formattedOrgData', formattedOrgData)
      console.log(selectedDate)

      const filteredByDate = formattedOrgData.filter(
        row =>
          row.date && moment(row.date).format('YYYY-MM-DD') === selectedDate
      )

      console.log(filteredByDate)

      setAuditData(filteredByDate)
      setIsDataFetched(true)

      const uniqueCaseIds = [...new Set(filteredByDate.map(row => row.caseId))]
      const uniqueUsernames = [...new Set(filteredByDate.map(row => row.agent))]

      setCaseIds(uniqueCaseIds)
      setUsernames(uniqueUsernames)
    } catch (error) {
      console.error('Error fetching org data:', error)
      setAuditData([])
      setIsDataFetched(true)
    }
  }

  const fetchAuditData = async () => {
    if (org_id) {
      setIsRefreshing(true)
      await fetchOrgData(org_id)
      setIsRefreshing(false)
      setShowRefreshMsg(true)
      setTimeout(() => {
        setShowRefreshMsg(false)
      }, 2000)
    }
  }

  const toggleDateSort = () => {
    let sortedData

    if (dateSortOrder === 'default' || dateSortOrder === 'asc') {
      sortedData = [...auditData].sort(
        (a, b) => new Date(b.date) - new Date(a.date) // Latest first
      )
      setDateSortOrder('desc')
    } else {
      sortedData = [...auditData].sort(
        (a, b) => new Date(a.date) - new Date(b.date) // Oldest first
      )
      setDateSortOrder('asc')
    }

    setAuditData(sortedData)
  }

  const toggleOrgSort = () => {
    let sortedData

    if (orgSortOrder === 'default' || orgSortOrder === 'desc') {
      sortedData = [...auditData].sort((a, b) => a.agent.localeCompare(b.agent))
      setOrgSortOrder('asc')
    } else if (orgSortOrder === 'asc') {
      sortedData = [...auditData].sort((a, b) => b.agent.localeCompare(a.agent))
      setOrgSortOrder('desc')
    }

    setAuditData(sortedData)
  }

  // Call fetchOrgData inside useEffect when orgID is available
  useEffect(() => {
    if (org_id) {
      fetchOrgData(org_id)
    }
  }, [selectedDate])

  const link_to_pdf = async audit_id => {
    // ✅ S3 object key format (must match backend convention)
    const objectKey = `Insurance_Inspection/downloadedPdf/${audit_id}.pdf`

    try {
      const response = await fetch('/auth/check_document_exists', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ objectKey }) // ✅ send S3 key
      })

      const data = await response.json()
      console.log('S3 PDF response:', audit_id, data)

      if (data.exists && data.url) {
        return data.url // signed S3 URL if found
      } else {
        return null // file not found
      }
    } catch (error) {
      console.error('Error fetching signed S3 URL:', error)
      return null
    }
  }
  const [pdfLinks, setPdfLinks] = useState({})

  useEffect(() => {
    const checkAllLinks = async () => {
      const links = {}
      for (const row of auditData) {
        const url = await link_to_pdf(row.audit) // 🔍 check S3 here
        if (url) {
          links[row.audit] = url
        }
      }
      setPdfLinks(links)
    }

    if (auditData.length > 0) {
      checkAllLinks()
    }
  }, [auditData])
  const getStatusClass = status => {
    switch (status.toLowerCase()) {
      case 'processing':
        return { backgroundColor: 'rgba(247, 165, 29, 1)', color: 'white' }
      case 'processed':
      case 'completed':
        return { backgroundColor: 'rgba(31, 68, 136, 1)', color: 'white' }
      case 'accessed':
        return { backgroundColor: '#ff0083', color: 'white' }
      default:
        return { backgroundColor: 'grey', color: 'white' }
    }
  }

  const filteredData = auditData.filter(
    row =>
      row.caseId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.agent.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.status.toLowerCase().includes(searchTerm.toLowerCase())
  )
  // console.log('213', filteredData)

  const [showRemarkPopup, setShowRemarkPopup] = useState(false)
  const [selectedRemark, setSelectedRemark] = useState('')
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [showRefreshMsg, setShowRefreshMsg] = useState(false)
  const [orgSortOrder, setOrgSortOrder] = useState('default') // none | asc | desc
  const [dateSortOrder, setDateSortOrder] = useState('default')

  return (
    <div className='inspect-container'>
      <div className='card'>
        <div className='card-header'>
          <h2>Inspect</h2>
          <div className='search-refresh-container'>
            <div className='search-bar'>
              <input
                type='text'
                placeholder='Search ...'
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              <img src={searchIcon} alt='Search' className='search-icon' />
            </div>

            <div
              className={`refresh-icon-wrapper ${
                isRefreshing ? 'spinning' : ''
              }`}
              onClick={fetchAuditData}
              title='Refresh'
            >
              <img src={refreshIcon} alt='refresh' className='refresh-icon' />
            </div>
          </div>
        </div>

      <div className='filters'>
  <input
    type='date'
    value={selectedDate}
    onChange={e => setSelectedDate(e.target.value)}
  />

  <select>
    <option>
      {orgName || userDataStore?.org_name || 'Organisation'}
    </option>
  </select>

  <select>
    <option>All Case ID</option>
    {caseIds.map((caseId, index) => (
      <option key={index} value={caseId}>
        {caseId}
      </option>
    ))}
  </select>

  <select>
    <option>Program Name</option>
    {programs.map((progname, index) => (
      <option key={index} value={progname}>
        {progname}
      </option>
    ))}
  </select>
</div>


        <div className='table-wrapper'>
          <table>
            <thead>
              <tr>
                <th>
                  Date
                  <span
                    className='sort-icon'
                    onClick={toggleDateSort}
                    title='Sort by Date'
                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                  >
                    ⬍
                  </span>
                </th>{' '}
                <th>Case ID</th>
                <th>Status</th>
                <th>Report</th>
                <th>
                  Program Name
                  {/* <span
                    className='sort-icon'
                    onClick={toggleOrgSort}
                    title='Sort by Agent Name'
                    style={{ marginLeft: '5px', cursor: 'pointer' }}
                  >
                    ⬍
                  </span> */}
                </th>{' '}
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              {!isDataFetched ? (
                <tr>
                  <td colSpan='6' className='no-results'>
                    No data available
                  </td>
                </tr>
              ) : filteredData.length > 0 ? (
                filteredData.map((row, index) => {
                  const pdfUrl = link_to_pdf(row.caseId)
                  return (
                    <tr key={index}>
                      <td>{row.date}</td>
                      <td>{row.caseId}</td>
                      <td>
                        <span
                          className='status'
                          style={getStatusClass(row.status)}
                        >
                          {row.status}
                        </span>
                      </td>
                      {/* <td>
                        {row.status === "processed" ? (
                          <a
                            href={pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#ff0083",
                              textDecoration: "none",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "inline-block",
                              maxWidth: "150px",
                              verticalAlign: "middle",
                              padding: "2px",
                            }}
                            title={pdfUrl}
                          >
                            View
                          </a>
                        ) : (
                          "Not generated"
                        )}
                      </td> */}
                      <td>
                        {row.status === 'processed' && pdfLinks[row.audit] ? (
                          <a
                            href={pdfLinks[row.audit]}
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{
                              color: '#ff0083',
                              textDecoration: 'none',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              display: 'inline-block',
                              maxWidth: '150px',
                              verticalAlign: 'middle',
                              padding: '2px'
                            }}
                            title={pdfLinks[row.audit]}
                          >
                            View
                          </a>
                        ) : (
                          'Not generated'
                        )}
                      </td>
                      <td>{row.program}</td>
                      <td>
                        {row.remark && row.status === 'processed' ? (
                          <div
                            className='tooltip-container clickable'
                            title={row.remark}
                            onClick={() => {
                              setSelectedRemark(row.remark)
                              setShowRemarkPopup(true)
                            }}
                          >
                            <img
                              src={remarkIcon}
                              alt='Remark'
                              className='remark-icon'
                              style={{
                                filter:
                                  'brightness(90) saturate(0%) invert(21%) sepia(92%) saturate(7030%) hue-rotate(308deg) brightness(100%) contrast(124%)'
                              }}
                            />
                          </div>
                        ) : (
                          <div className='tooltip-container'>
                            <img
                              src={remarkIcon}
                              alt='No Remark'
                              className='remark-icon'
                              style={{
                                filter: 'grayscale(100%) brightness(80%)'
                              }}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan='6' className='no-results'>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showRemarkPopup && (
        <div
          className='remark-popup-overlay'
          onClick={() => setShowRemarkPopup(false)}
        >
          <div className='remark-popup' onClick={e => e.stopPropagation()}>
            <h3>Remark</h3>
            <p>{selectedRemark}</p>
            <button onClick={() => setShowRemarkPopup(false)}>Close</button>
          </div>
        </div>
      )}
      {showRefreshMsg && <div className='refresh-toast'>Table Refreshed</div>}
    </div>
  )
}

export default IamSidebar
